module.exports = __webpack_public_path__ + "static/logoFE-EN-4f1ae663dfada2b03dd3273c404b4622.svg";